'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonLink = require('../../01.atoms/ButtonLink/ButtonLink.js');
var ButtonPlain = require('../../01.atoms/ButtonPlain/ButtonPlain.js');
var Headline = require('../../01.atoms/Headline/Headline.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-text';
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Text(_ref) {
  var button = _ref.button,
      className = _ref.className,
      content = _ref.content,
      headlineLevel = _ref.headlineLevel,
      headline = _ref.headline,
      style = _ref.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className, _rollupPluginBabelHelpers.defineProperty({}, "".concat(CLASSNAME, "--").concat(style), style))
  }, /*#__PURE__*/React__default.createElement(Headline, {
    level: headlineLevel
  }, headline), content && /*#__PURE__*/React__default.createElement(RichText, {
    content: content
  }), button && button.cta && /*#__PURE__*/React__default.createElement(ButtonPlain, {
    title: button.title,
    link: button.link,
    onClick: button.onClick,
    type: style === 'light' ? 'secondary' : 'primary'
  }), button && !button.cta && /*#__PURE__*/React__default.createElement(ButtonLink, {
    title: button.title,
    link: button.link,
    iconId: button.iconId || 'caret-right',
    onClick: button.onClick,
    type: "secondary",
    style: style,
    bold: true
  }));
}
Text.propTypes = {
  /** Button object */
  button: PropTypes.shape({
    link: PropTypes.string,
    title: PropTypes.string,
    cta: PropTypes.bool,
    iconId: PropTypes.string,
    onClick: PropTypes.func
  }),

  /** Additional class name */
  className: PropTypes.string,

  /** Content text */
  content: PropTypes.string,

  /** Level of headline e.g. 1 for h1 */
  headlineLevel: PropTypes.number,

  /** Title string */
  headline: PropTypes.string.isRequired,

  /** Style options */
  style: PropTypes.oneOf(['light', 'dark'])
};

module.exports = Text;
